<template>
    <ul class="dropdown-actions dropdown-menu shadow-md" v-if="can_edit_calendars">
        <template v-if="on_tour">
            <li>
                <a href="" @click.prevent="selectForm('clientBooking')">
                    <i class="zmdi zmdi-account"></i>
                    <span>{{ trans('calendar.choose_booking_type_create_client') }}</span>
                </a>
            </li>
        </template>
        <template v-else>
            <li>
                <a href="" class="" @click.prevent="selectForm('clientBooking')">
                    <i class="zmdi zmdi-account"></i>
                    <span>{{ trans('calendar.choose_booking_type_create_client') }}</span>
                </a>
            </li>
            <li>
                <a href="" @click.prevent="selectForm('otherBooking')">
                    <i class="zmdi zmdi-calendar-alt"></i>
                    <span>{{ trans('calendar.choose_booking_type_create_other') }}</span>
                </a>
            </li>
            <li v-if="isEventsActive">
                <a href="" @click.prevent="selectForm('event')">
                    <i class="zmdi zmdi-accounts"></i>
                    <span>{{ trans('calendar.choose_booking_type_create_event') }}</span>
                </a>
            </li>
            <li v-if="isOnlineBookingActive">
                <a href="" @click.prevent="selectForm('closeBooking')">
                    <i class="zmdi zmdi-calendar-close"></i>
                    <span>{{ trans('calendar.choose_booking_type_create_close') }}</span>
                </a>
            </li>
            <li v-if="isWaitingListActive">
                <a href="" @click.prevent="selectForm('waitingList')">
                    <i class="zmdi zmdi-accounts-list"></i>
                    <span>{{ trans('waiting_list.waiting_list_button') }}</span>
                </a>
            </li>
            <li v-if="isUserManagementEnabled && isTeamMeetingsAppActive">
                <a href="" @click.prevent="selectForm('TeamMeetingFormModal')">
                    <i class="zmdi zmdi-accounts-add"></i>
                    <span>{{ trans('apps.team_meetings.create')  }}</span>
                </a>
            </li>
            <li v-if="isOtherPayersAppActive">
                <a href="" @click.prevent="selectForm('ContactBookingModal')">
                    <i class="zmdi zmdi-account-calendar"></i>
                    <span>{{ trans('apps.other_payers.contact_bookings.create_a')  }}</span>
                </a>
            </li>
        </template>
    </ul>
</template>

<script>
import Apps from '@/core/Apps'
import { useCalendarSidebarStore, SidebarViews } from 'Components/calendar/calendar_sidebar/store/calendarSidebarStore';
import { mapStores } from 'pinia';

export default {
    props: {
        selectedStart: {
            type: Object,
            required: false,
            default: null,
        },
        selectedEnd: {
            type: Object,
            required: false,
            default: null,
        },
        selectedCalendar: {
            type: String,
            required: false,
            default: null,
        },
        timeSelected: {
            type: Boolean,
            required: false,
            default: false,
        },
        on_tour: {
            type: Boolean,
            required: false,
            default: false,
        },
        calendar_sidebar_enabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        selectForm(formType) {
            const forms = {
                clientBooking: 'showCreateClientBooking',
                otherBooking: 'showCreateOtherBooking',
                closeBooking: 'showCreateCloseBooking',
                event: 'showCreateEvent',
                waitingList: 'showAddWaitingListEntryModal',
                TeamMeetingFormModal: 'showTeamMeetingFormModal',
                ContactBookingModal: 'showCreateContactBooking',
            }

            const event = forms[formType]

            // If there is no form mapping do nothing
            if (!event) return

            let calendarId = this.selectedCalendar

            // If there is no selected calendar from resource view check if there is only one calendar active
            if (!calendarId && this.activeCalendars.length === 1) {
                calendarId = this.activeCalendars[0].id
            }

            const params = { calendarId }

            if (this.timeSelected) {
                if (formType === 'waitingList') {
                    params.preferred_time = this.selectedStart
                } else {
                    params.start = this.selectedStart
                    params.end = this.selectedEnd
                }
            }

            if (event === 'showCreateClientBooking' && this.calendar_sidebar_enabled) {
                this.calendarSidebarStore.navigateTo(SidebarViews.CREATE_CLIENT_BOOKING, { ...params, mode: 'create' });
            } else if (event === 'showCreateOtherBooking' && this.calendar_sidebar_enabled) {
                this.calendarSidebarStore.navigateTo(SidebarViews.CREATE_OTHER_BOOKING, { ...params, mode: 'create' });
            } else {
                this.$event_bus.$emit(event, params)
            }

            this.$emit('option-selected')
        }
    },
    computed: {
        isEventsActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Events)
        },
        isWaitingListActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.WaitingList)
        },
        isOnlineBookingActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.OnlineBooking);
        },
        activeCalendars() {
            return this.$store.getters['calendars/getActiveCalendars']
        },
        can_edit_calendars() {
          return this.$store.getters['calendars/getCalendars']().filter((calendar) => {
            return calendar.can_edit;
          }).length > 0;
        },

        isUserManagementEnabled() {
            return this.$store.getters['apps/isAppEnabled'](Apps.UserManagement)
                || this.$store.getters['apps/isAppEnabled'](Apps.Tenants);
        },

        isTeamMeetingsAppActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.TeamMeetings);
        },

        isOtherPayersAppActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.OtherPayers);
        },

        ...mapStores(useCalendarSidebarStore),
    }
}
</script>
